// extracted by mini-css-extract-plugin
export default {"spinner":"VerifyEmailSpinner_spinner__Bcp37","rotate":"VerifyEmailSpinner_rotate__jpMCn","prixClipFix":"VerifyEmailSpinner_prixClipFix__BpK9c"};